import { blue, red } from "@ant-design/colors";
import { Image, Modal, Space, Switch, Typography } from "antd";
import { ColumnsType } from "antd/es/table";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { StrapiImage } from "../../../interfaces/strapi.interface";
import { Announcement } from "../../../interfaces/announcement.interface";

export type GenerateColumnsOptions = {
  onClickDetail: (data: Announcement, index: number) => void;
  onClickEdit: (data: Announcement, index: number) => void;
  onClickDelete: (data: Announcement, index: number) => void;
  onUpdateIsActive: (
    updatedValue: boolean,
    data: Announcement,
    index: number
  ) => void;
};

const generateColumns = (
  options: GenerateColumnsOptions
): ColumnsType<Announcement> => {
  const columns: ColumnsType<Announcement> = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text: string, record, index) => (
        <Typography.Text
          style={{ color: blue.primary, cursor: "pointer" }}
          onClick={() => {
            options.onClickDetail(record, index);
          }}
        >
          {text}
        </Typography.Text>
      ),
    },
    {
      title: "Cover Image",
      dataIndex: "coverImage",
      key: "coverImage",
      render: (data: StrapiImage) => {
        if (data) {
          return (
            <Image
              style={{
                maxHeight: 100,
              }}
              src={data.url}
            />
          );
        }
        return null;
      },
    },
    {
      title: "Active",
      dataIndex: "isActive",
      key: "isActive",
      render: (data: boolean, record, index) => {
        return (
          <Switch
            checked={data}
            onChange={(checked) => {
              options.onUpdateIsActive(checked, record, index);
            }}
          />
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record, index) => (
        <Space size="middle">
          <EditOutlined
            style={{ color: blue.primary }}
            onClick={() => {
              options.onClickEdit(record, index);
            }}
          />
          <DeleteOutlined
            style={{ color: red.primary }}
            onClick={() => {
              Modal.confirm({
                title: "Delete Announcement",
                content: `Are you sure you want to delete?`,
                icon: <DeleteOutlined />,
                onOk() {
                  options.onClickDelete(record, index);
                },
              });
            }}
          />
        </Space>
      ),
    },
  ];

  return columns;
};

export default generateColumns;
